<template>
  <div class="search-wrapper">
    <search-layout-input
      v-if="!searchObject.searchResult || isMobile"
      :search-layout-comps="searchLayoutComps"
      :search-type-options="searchTypeOptions"
      @on-search-clicked="onSearchClicked"
      @toggle-search-type="toggleSearchType"
    />
    <search-result-layout
      v-else
      :search-layout-comps="searchLayoutComps"
      :search-type-options="searchTypeOptions"
      @on-search-clicked="onSearchClicked"
      @toggle-search-type="toggleSearchType"
    />
    <search-page-content
      v-if="!isMobile"
      :search-object="searchObject"
      :top-header="getTopHeader"
      @open-display-property="showPropertyDetails"
      @load-more-clicked="assignSearchElement"
      @marker-clicked="onMapMarkerClicked"
    />
  </div>
</template>

<script>
import searchContent from '../../components/mixins/searchContent'

export default {
  mixins: [searchContent],

  methods: {
    onSearchClicked() {
      this.startSearch()
      if (this.isMobile) {
        this.$router.push({
          name: `client-search-results`
        })
      }
    }
  }
}
</script>

<style lang="sass" scoped>
.search-wrapper
  @media only screen and (max-width: 600px)
    height: 100%

#lazyLoader
  margin: 5rem 0 10rem
</style>
